module.exports = __webpack_public_path__ + "static/media/delta.6034ba7a.png";